/** Existing series identities, kept stable pending the design workbook. */
export const VISUALIZATION_TOKENS = Object.freeze({
  series: Object.freeze({
    1: Object.freeze([
      "#507a96",
      "#93a4ca",
      "#8772ac",
      "#c383b8",
      "#e685aa",
      "#ff8953",
      "#ff8e91",
      "#ffba5d",
      "#8fbb7c",
      "#60c4c0",
      "#3980C0",
      "#F78E91",
      "#4BAFE1",
      "#52AF98",
    ]),
    2: Object.freeze([
      "#0F5A93",
      "#19659F",
      "#0E76BD",
      "#2F8FCC",
      "#43A6DD",
      "#60C1EC",
    ]),
    3: Object.freeze([
      "#00BFFF",
      "#17e3cf",
      "#fb607f",
      "#F38E7C",
      "#FEB420",
      "#3ccf67",
      "#9375eb",
    ]),
  }),
  channels: Object.freeze({
    TikTok: "#000000",
    PMax: "#F5C24D",
    DOOH: "#A04000",
    CTV: "#0097A7",
    Waze: "#4F46E5",
    Yelp: "#D32323",
    Youtube: "#F32B2B",
    Pinterest: "#E60023",
    Instagram: "#EC3BB1",
    Facebook: "#1F2937",
    Linkedin: "#0A66C2",
    Audio: "#0f0a69",
    Ecomm: "#374151",
    Video: "#34D399",
    Display: "#34A853",
    Search: "#41A28C",
  }),
  areaFill: "rgba(9, 171, 167, 0.1)",
  progressStroke: "#097CA3",
});
// Retain existing brand-series assignments; do not recolor series to UI primary.
export const getBrandSeriesColor = (index: number) =>
  `hsl(${(index * 137.508) % 360}, 65%, 55%)`;
